import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import { projectKeys } from './useProjects';
import type {
  CmeStatusResponse,
  CmeGenerateInput,
  CmeResult,
  BulkCreatePreventiviInput,
  BulkCreatePreventiviResponse,
  AnalyzeQuoteInput,
  ExtractDocumentInput,
  DocumentExtractResult,
  BulkImportInput,
  BulkImportResponse,
} from '../types';

export function useCmeStatus() {
  return useQuery({
    queryKey: ['cme', 'status'],
    queryFn: () => api.get<CmeStatusResponse>('/cme/status'),
    staleTime: 5 * 60 * 1000,
  });
}

export function useGenerateCme() {
  return useMutation({
    mutationFn: (data: CmeGenerateInput) =>
      api.post<CmeResult>('/cme/generate', data),
  });
}

export function useBulkCreatePreventivi() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: BulkCreatePreventiviInput) =>
      api.post<BulkCreatePreventiviResponse>('/cme/bulk-save', data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}

export function useAnalyzeQuote() {
  return useMutation({
    mutationFn: (data: AnalyzeQuoteInput) =>
      api.post<CmeResult>('/cme/analyze-quote', data),
  });
}

export function useExtractDocument() {
  return useMutation({
    mutationFn: (data: ExtractDocumentInput) =>
      api.post<DocumentExtractResult>('/cme/extract-document', data),
  });
}

export function useBulkImport() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: BulkImportInput) =>
      api.post<BulkImportResponse>('/cme/bulk-import', data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: projectKeys.detail(variables.projectId),
      });
    },
  });
}
